import { useNavigate } from "react-router";
import { useTypedSearchParams } from "react-router-typesafe-routes";

import { ClientApplicationUsageByUsersModal } from "@components/Modals";

import { routes } from "@pages/routes";

export const ApplicationUsageByUsers = () => {
  const navigate = useNavigate();
  const [{ date }] = useTypedSearchParams(
    routes.portal.clients.client.dashboard.applicationUsageByUsers,
  );

  const handleClose = () => {
    navigate("..", { viewTransition: true });
  };

  return (
    <ClientApplicationUsageByUsersModal
      isOpen
      onClose={handleClose}
      date={date}
    />
  );
};
